import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../data/site";
import { PageHero, Reveal, SectionTag } from "../components/Reveal";

const Operacoes = () => {
  const { t } = useLanguage();
  const p = t.operations;

  const images = [IMAGES.lithoBulk, IMAGES.stsOperation, IMAGES.terminalFront, IMAGES.bunkerDeck, IMAGES.containerShip];

  return (
    <main data-testid="operations-page">
      <PageHero chip={p.chip} title={p.title} sub={p.sub} testid="operations-hero" />

      {p.sections.map((s, i) => (
        <section
          key={s.title}
          data-testid={`operation-block-${i}`}
          className={`px-6 lg:px-12 py-20 border-b border-ops ${i % 2 === 1 ? "bg-ops-panel/60" : ""}`}
        >
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className={`lg:col-span-6 space-y-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <div className="flex items-center gap-4">
                <span className="font-display text-5xl font-extrabold text-ops-light/25">{String(i + 1).padStart(2, "0")}</span>
                <SectionTag>{s.tag}</SectionTag>
              </div>
              <Reveal>
                <h2 className="font-display text-2xl sm:text-4xl font-extrabold uppercase text-white leading-tight">{s.title}</h2>
              </Reveal>
              <Reveal delay={0.1}>
                <p className="text-sm text-ops-muted leading-relaxed max-w-xl">{s.text}</p>
              </Reveal>
              <Reveal delay={0.15}>
                <ul className="space-y-2.5">
                  {s.points.map((pt) => (
                    <li key={pt} className="flex items-center gap-3 text-sm text-white">
                      <Check size={15} className="text-ops-light shrink-0" />
                      {pt}
                    </li>
                  ))}
                </ul>
              </Reveal>
            </div>
            <Reveal delay={0.1} className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <div className="rounded-2xl overflow-hidden border border-ops aspect-[16/10]">
                <img
                  src={images[i]}
                  alt={s.title}
                  loading="lazy"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
            </Reveal>
          </div>
        </section>
      ))}

      <section className="px-6 lg:px-12 py-20">
        <div className="max-w-7xl mx-auto text-center">
          <Reveal>
            <Link
              to="/contato"
              data-testid="operations-cta"
              className="inline-flex items-center gap-2 px-8 py-4 bg-ops-light text-ops-base text-xs font-display font-bold uppercase tracking-widest rounded hover:bg-white transition-colors"
            >
              {p.cta} <ArrowRight size={14} />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Operacoes;
